/// <amd-module name="Repos/Views/PullRequest/Util/Policy" />
import { PolicyEvaluationStatus } from "Repos/Common/Contracts/Policy";
import {
    IMergeStrategyPolicyEvaluation,
    IPullRequestPolicyEvaluation,
    IRequiredReviewersPolicyEvaluation,
    PolicyTypeId
} from "../Contracts/PullRequest";

export function getBlockingPolicies(policies: IPullRequestPolicyEvaluation[]): IPullRequestPolicyEvaluation[] {
    return policies.filter(p => p.isBlocking && p.status !== PolicyEvaluationStatus.Approved);
}

export function getMergePolicy(policies: IPullRequestPolicyEvaluation[]): IMergeStrategyPolicyEvaluation | undefined {
    return policies.find(p => p.policyType.id === PolicyTypeId.mergeStrategy) as IMergeStrategyPolicyEvaluation;
}

export function getAutomaticReviewerPolicies(policies: IPullRequestPolicyEvaluation[]): IRequiredReviewersPolicyEvaluation[] {
    return policies.filter(p => p.policyType.id === PolicyTypeId.automaticReviewers) as IRequiredReviewersPolicyEvaluation[];
}

/**
 * Gets the policies that belong to reviewers (no status checks)
 */
export function getReviewerRelatedPolicies(policies: IPullRequestPolicyEvaluation[]): IPullRequestPolicyEvaluation[] {
    return policies.filter(p => p.policyType.id === PolicyTypeId.automaticReviewers || p.policyType.id === PolicyTypeId.approvalCount);
}

/**
 * Gets the policies status checks policies (no reviewers related)
 */
export function getCheckPolicies(policies: IPullRequestPolicyEvaluation[]): IPullRequestPolicyEvaluation[] {
    return policies.filter(
        p =>
            p.policyType.id === PolicyTypeId.build ||
            p.policyType.id === PolicyTypeId.commentResolution ||
            p.policyType.id === PolicyTypeId.status ||
            p.policyType.id === PolicyTypeId.workItemLinking
    );
}

export function getUnsatisfiedPolicies(policies: IPullRequestPolicyEvaluation[]): IPullRequestPolicyEvaluation[] {
    // Merge policy is always present even when the branch is not protected.
    // We can safely ignore it even if it's blocking, as it's only applied at completion time, not before, so we cannot wait on it.
    return policies.filter(p => p.status !== PolicyEvaluationStatus.Approved && p.policyType.id !== PolicyTypeId.mergeStrategy);
}
